import React from "react";
import ComplianceSection from "../../components/ComplianceSection/ComplianceSection";

const VehicleCompliance = () => {
  return <ComplianceSection />;
};

export default VehicleCompliance;
